module.exports = __webpack_public_path__ + "img/logo-GE.ba6d2ab3.png";